/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：287
 */

"use strict"

export { o as a }
import { useMemo } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_697 from /* 697 */"../../../551/1211/269/697"
function o(e, t) {
  return useMemo(function () {
    return null == e && null == t ? null : function (n) {
      Module_697.a(e, n)
      Module_697.a(t, n)
    }
  }, [e, t])
}
export default o
